import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { IParams } from '../model/http';
import { IResponseWithData } from '../interfaces';
import {
  AutomationPlannerItem,
} from '../modules/crm/automation-v2/components-v2/automation-v2/automation-v2.interface';
import type {
  AutomationLogDetails,
  AutomationLogGroupItem,
} from '../modules/crm/automation-v2/components-v2/automation-logs/automation-logs.interface';
import { AUTOMATION_TYPE, ResponseItemsWithParams } from '../enum/constants';


@Injectable({
  providedIn: 'root',
})
export class AutomationService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
  ) {
  }

  public updateSettingsChat(payload: any) {
    return this.http.post<any>(environment.baseURL + '/automation', payload)
      .pipe(map(res => res.data));
  }

  public createAutomation(payload: any) {
    return this.http.post<any>(environment.baseURL + '/automation', payload)
      .pipe(map(res => res.data));
  }

  public updateAutomation(automation_id: string, payload: any) {
    return this.http.put<any>(environment.baseURL + `/automation/${automation_id}`, payload)
      .pipe(map(res => res.data));
  }

  public getSettingsChat() {
    return this.http.get<any>(environment.baseURL + '/automation')
      .pipe(map(res => res.data));
  }

  public deleteSettingsChat(id: any) {
    return this.http.delete<any>(environment.baseURL + `/automation/${id}`);
  }

  public delete(id: string) {
    return this.http.delete<any>(environment.baseURL + `/automation/${id}`);
  }


  public getAutomationById(id: any) {
    return this.http.get<any>(environment.baseURL + `/automation/${id}`)
      .pipe(map(res => res.data));
  }


  public getAllAIModels() {
    return this.http.get<any>(environment.baseURL + '/ai/models')
      .pipe(map(res => res.data));
  }

  public getAllTypes() {
    return this.http.get<any>(environment.baseURL + '/automation/types')
      .pipe(map(res => res.data));
  }

  public getAllTgUsers(params: any) {
    return this.http.get<any>(environment.baseURL + '/tg/users', { params })
      .pipe(map(res => res.data));
  }

  public getAutomationAll(params: {
    page: number;
    take: number;
    sort?: string;
    order?: string;
    is_enable?: boolean;
    type?: AUTOMATION_TYPE;
  } = {
    page: 1,
    take: 25,
  }) {
    return this.http
      .post<any>(environment.baseURL + '/automation/all', params)
      .pipe(map(res => res.data));
  }

  getAutomationPlanners(params: IParams): Observable<ResponseItemsWithParams<AutomationPlannerItem>> {
    return this.http.post<IResponseWithData<ResponseItemsWithParams<AutomationPlannerItem>>>(
      `${environment.baseURL}/automation/planners`, params,
    ).pipe(map(v => v.data));
  }

  getAutomationLogs(
    automationId: string,
    params: IParams,
  ): Observable<ResponseItemsWithParams<AutomationLogGroupItem>> {
    return this.http.post<IResponseWithData<ResponseItemsWithParams<AutomationLogGroupItem>>>(
      `${environment.baseURL}/automation/${automationId}/logs`, params,
    ).pipe(map(v => v.data));
  }

  getAutomationLogDetails(
    automationId: string,
    taskId: string,
  ): Observable<AutomationLogDetails> {
    return this.http.get<IResponseWithData<AutomationLogDetails>>(
      `${environment.baseURL}/automation/${automationId}/logs/${taskId}`,
    ).pipe(map(v => v.data));
  }
}
